__turbopack_context__.v({
  "className": "inter_dc5445b3-module__gpOlYa__className",
  "variable": "inter_dc5445b3-module__gpOlYa__variable",
});
